module.exports = __webpack_public_path__ + "static/media/send.c78115fa.svg";